import { eTypePosition } from '../../../enums/eTypePosition'

export const COMMENT_REQUIRED_POSITION_TYPES = [
  eTypePosition.Merma,
  eTypePosition.Diferencia,
  eTypePosition.Calidad,
  eTypePosition.CalidadTransferencia
] as const

export const checkIfCommentsRequired = (
  originTypeId?: number,
  destinyTypeId?: number
): boolean => {
  const originEnableComments = originTypeId &&
    COMMENT_REQUIRED_POSITION_TYPES.includes(originTypeId)

  const destinyEnableComments = destinyTypeId &&
    COMMENT_REQUIRED_POSITION_TYPES.includes(destinyTypeId)

  return Boolean(originEnableComments || destinyEnableComments)
}
